module.exports = __webpack_public_path__ + "static/homepage-hero-5be2bd2bcf91cf5473ba56b78f9316e6.webm";